export default class User {
  constructor(user) {
    this.key = user.key;
    this.name = user.name;
  }
}
